import { render, staticRenderFns } from "./segments-table-loader.vue?vue&type=template&id=22e5dd48"
import script from "./segments-table-loader.vue?vue&type=script&lang=js"
export * from "./segments-table-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports